import { TAssessmentCentreFiltersPayload } from "services/assessmentCentre";
import { paceData } from "../config";
import { Team } from "services";

export const normalizeAssessmentCentreFilters = (
    filters: Partial<TAssessmentCentreFiltersPayload>,
    teamsData: Team[]
) => {
    const isTeamsDefault = filters.filter_teams?.some((val) => val === "all");
    const isPaceStatusDefault = filters.filter_pace_status?.some((val) => val === "ALL");

    return {
        ...(filters.filter_name ? { filter_name: filters.filter_name } : {}),
        ...(isPaceStatusDefault
            ? {}
            : {
                  filter_pace_status: filters.filter_pace_status?.map(
                      (id) => paceData.find((p) => p.id === id)?.id || ""
                  ),
              }),
        ...(isTeamsDefault
            ? {}
            : {
                  filter_teams: filters.filter_teams?.flatMap(
                      (name) => teamsData.find((p) => p.name === name)?.name || ""
                  ),
              }),
        page_no: filters.page_no || 1,
    };
};
